export default __webpack_public_path__ + "static/media/Union (1).12626a7d.svg";